import { render } from "./EntitySelectorMunicipio.vue?vue&type=template&id=3fdf863a"
import script from "./EntitySelectorMunicipio.vue?vue&type=script&lang=ts"
export * from "./EntitySelectorMunicipio.vue?vue&type=script&lang=ts"
script.render = render

export default script